module.exports = __webpack_public_path__ + "static/media/gender-women.b0a1c6b2.svg";